(function(){
  if(customElements.get('signet-ring-builder')) return;
  class SignetRingBuilder extends HTMLElement{
    connectedCallback(){
      this.data=JSON.parse(this.querySelector('[data-builder-data]').textContent);
      this.form=this.querySelector('form');
      this.variant=this.data.variants.find(v=>String(v.id)===this.querySelector('[data-main-variant]').value)||this.data.variants[0];
      this.querySelectorAll('[data-variant-id]').forEach(b=>b.addEventListener('click',()=>this.selectVariant(b)));
      this.querySelectorAll('[data-addon]').forEach(r=>r.addEventListener('change',()=>this.updateEngraving()));
      this.querySelector('[data-inside-toggle]')?.addEventListener('change',e=>this.updateInside(e.target.checked));
      this.querySelector('[data-monogram-input]')?.addEventListener('input',e=>{this.querySelector('[data-monogram]').textContent=e.target.value.slice(0,4).toUpperCase()});
      this.form.addEventListener('submit',e=>this.submit(e));
      this.updatePrice();
    }
    money(cents){
      if(window.Shopify?.formatMoney) return Shopify.formatMoney(cents,this.data.moneyFormat);
      return new Intl.NumberFormat(document.documentElement.lang||'en-GB',{style:'currency',currency:window.Shopify?.currency?.active||'GBP'}).format(cents/100);
    }
    selectVariant(button){
      const next=this.data.variants.find(v=>String(v.id)===button.dataset.variantId); if(!next)return;
      this.variant=next; this.querySelector('[data-main-variant]').value=next.id;
      this.querySelectorAll('[data-variant-id]').forEach(b=>{const on=b===button;b.classList.toggle('is-selected',on);b.setAttribute('aria-pressed',String(on))});
      this.querySelector('[data-summary-variant]').textContent=next.title;
      this.querySelector('[data-submit]').disabled=!next.available;
      const image=this.querySelector('.srb__image'); if(image&&next.image) image.src=next.image;
      this.updatePrice();
    }
    updateEngraving(){
      const chosen=this.querySelector('[data-addon]:checked');
      this.querySelectorAll('.srb__choices--engraving .srb__choice').forEach(l=>l.classList.toggle('is-selected',l.contains(chosen)));
      const show=chosen?.dataset.addon!=='none'; this.querySelector('[data-engraving-details]').hidden=!show;
      this.querySelectorAll('[data-engraving-details] input,[data-engraving-details] select').forEach(el=>el.disabled=!show);
      this.updatePrice();
    }
    updateInside(show){
      this.querySelector('[data-inside-details]').hidden=!show;
      this.querySelectorAll('[data-inside-input]').forEach(el=>{el.disabled=!show;if(show&&el.type==='text')el.required=true;else el.required=false});
      this.updatePrice();
    }
    selectedAddons(){
      const out=[]; const engraving=this.querySelector('[data-addon]:checked')?.dataset.addon;
      if(engraving&&engraving!=='none'&&this.data.addons[engraving]) out.push(this.data.addons[engraving]);
      if(this.querySelector('[data-inside-toggle]')?.checked&&this.data.addons.inside) out.push(this.data.addons.inside);
      return out;
    }
    updatePrice(){
      const total=this.variant.price+this.selectedAddons().reduce((n,a)=>n+a.price,0);
      this.querySelectorAll('[data-total]').forEach(el=>el.textContent=this.money(total));
      this.querySelector('[data-button-total]').textContent=this.money(total);
    }
    async submit(event){
      if(!this.form.reportValidity()){event.preventDefault();return}
      const addons=this.selectedAddons(); if(!addons.length) return;
      event.preventDefault(); const button=this.querySelector('[data-submit]'),status=this.querySelector('[data-status]');
      button.disabled=true;status.textContent='Adding your personalised ring…';
      const buildId='SR-'+Date.now().toString(36).toUpperCase(); this.querySelector('[data-build-id]').value=buildId;
      try{
        const response=await fetch(window.Shopify?.routes?.root+'cart/add.js',{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({items:addons.map(a=>({id:a.id,quantity:1,properties:{'_Builder reference':buildId,'For':'Personalised signet ring'}}))})});
        if(!response.ok) throw new Error('Add-on could not be added');
        this.form.submit();
      }catch(error){button.disabled=false;status.textContent='We could not add the engraving charge. Please try again.'}
    }
  }
  customElements.define('signet-ring-builder',SignetRingBuilder);
})();
